import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-clientele',
  templateUrl: './clientele.component.html',
  styleUrls: ['./clientele.component.scss']
})
export class ClienteleComponent implements OnInit {

  constructor() { }
  // services = [
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/bostLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/beatRouteLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/tripleplayLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/chqbookLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/gromoLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/simplifyLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/firLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/lecuineLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/albaNeraLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/igtLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/xebiaLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/accianLabsLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/3PillarLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/ustGlobalLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/cantechLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/digit88Logo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/spearLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/2bInnovationsLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/dubaiSportLogo.png'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/swsLogo.svg'
  //   },
  //   {
  //     iconUrl: '../../../../assets/images/patch/client-home/trgtLogo.png'
  //   },


  // ]
  services = [
    // pharmEasy
    {
      iconUrl: '../../../../assets/images/patch/client-home/pharmEasy.png'
    },
    // pokemon center
    {
      iconUrl: '../../../../assets/images/patch/client-home/pokemonCenter.png'
    },
    // pepper fry
    {
      iconUrl: '../../../../assets/images/patch/client-home/pepperfry.png'
    },
    // trgt
    {
      iconUrl: '../../../../assets/images/patch/client-home/trgtLogo.png'
    },

    // boat
    {
      iconUrl: '../../../../assets/images/patch/client-home/boat.png'
    },
    // boost
    {
      iconUrl: '../../../../assets/images/patch/client-home/bostLogo.png'
    },

    // zadinga
    {
      iconUrl: '../../../../assets/images/patch/client-home/zadinga.png'
    },
    // jio
    {
      iconUrl: '../../../../assets/images/patch/client-home/jio.png'
    },
    // usage
    {
      iconUrl: '../../../../assets/images/patch/client-home/usage.png'
    },
    // class plus
    {
      iconUrl: '../../../../assets/images/patch/client-home/classplus.png'
    },
    // brickNbolt
    {
      iconUrl: '../../../../assets/images/patch/client-home/brickNbolt.png'
    },
    // uolo
    {
      iconUrl: '../../../../assets/images/patch/client-home/uolo.png'
    },
    //xebia
    {
      iconUrl: '../../../../assets/images/patch/client-home/xebiaLogo.png'
    },
    //3pillar
    {
      iconUrl: '../../../../assets/images/patch/client-home/3PillarLogo.png'
    },
    //echo
    {
      iconUrl: '../../../../assets/images/patch/client-home/echo.png'
    },
    //chqbook
    {
      iconUrl: '../../../../assets/images/patch/client-home/chqbookLogo.png'
    },
    // delhivery
    {
      iconUrl: '../../../../assets/images/patch/client-home/delhivery.png'
    },
    // 2b
    {
      iconUrl: '../../../../assets/images/patch/client-home/2bInnovationsLogo.png'
    },
    // disc
    {
      iconUrl: '../../../../assets/images/patch/client-home/dubaiSportLogo.png'
    },
    // sws
    {
      iconUrl: '../../../../assets/images/patch/client-home/swsLogo.svg'
    },
    // digit88
    {
      iconUrl: '../../../../assets/images/patch/client-home/digit88Logo.png'
    },
    // canbrand
    {
      iconUrl: '../../../../assets/images/patch/client-home/cantechLogo.png'
    },
    // canvia
    {
      iconUrl: '../../../../assets/images/patch/client-home/canvia.png'
    },
    // spear
    {
      iconUrl: '../../../../assets/images/patch/client-home/spearLogo.png'
    },

    // ls technologies
    {
      iconUrl: '../../../../assets/images/patch/client-home/lsTech.png'
    },
    //rivigo
    {
      iconUrl: '../../../../assets/images/patch/client-home/rivigo.png'
    },
    //niyotail
    {
      iconUrl: '../../../../assets/images/patch/client-home/niyotail.png'
    },
    //grappus
    {
      iconUrl: '../../../../assets/images/patch/client-home/grappus.png'
    },
    //gromo
    {
      iconUrl: '../../../../assets/images/patch/client-home/gromoLogo.png'
    },
    //accionlabs
    {
      iconUrl: '../../../../assets/images/patch/client-home/accianLabsLogo.png'
    },
    //horizonx
    {
      iconUrl: '../../../../assets/images/patch/client-home/horizonx.png'
    },
    // beatroute
    {
      iconUrl: '../../../../assets/images/patch/client-home/beatRouteLogo.png'
    },
    //stage123
    {
      iconUrl: '../../../../assets/images/patch/client-home/stage123.png'
    },
    //fit
    {
      iconUrl: '../../../../assets/images/patch/client-home/firLogo.png'
    },
    //orahi
    {
      iconUrl: '../../../../assets/images/patch/client-home/orahi.png'
    },
    //simplify
    {
      iconUrl: '../../../../assets/images/patch/client-home/simplifyLogo.png'
    },

    //tripleplay
    {
      iconUrl: '../../../../assets/images/patch/client-home/tripleplayLogo.png'
    },
    //albanero
    {
      iconUrl: '../../../../assets/images/patch/client-home/albaNeraLogo.png'
    },
    // igt solutions
    {
      iconUrl: '../../../../assets/images/patch/client-home/igtLogo.png'
    },
    //ust global
    {
      iconUrl: '../../../../assets/images/patch/client-home/ustGlobalLogo.png'
    },
    //minstoak
    {
      iconUrl: '../../../../assets/images/patch/client-home/mintoak.png'
    },
    //niyox
    {
      iconUrl: '../../../../assets/images/patch/client-home/niyox.png'
    },
    // {
    //   iconUrl: '../../../../assets/images/patch/client-home/lecuineLogo.png'
    // },

  ]

  ngOnInit(): void {
    this.scroll();
  }

  scroll() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


}
